var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m346 151h-180c-8.284 0-15 6.716-15 15v180c0 8.284 6.716 15 15 15h180c8.284 0 15-6.716 15-15v-180c0-8.284-6.716-15-15-15zm-30 150c0 8.284-6.716 15-15 15h-90c-8.284 0-15-6.716-15-15v-90c0-8.284 6.716-15 15-15h90c8.284 0 15 6.716 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211 105c0-8.284-6.716-15-15-15s-15 6.716-15 15v16h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331 15c0-8.284-6.716-15-15-15s-15 6.716-15 15v106h30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196 60h45v61h30v-76c0-8.284-6.716-15-15-15h-45v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v30c0 8.284 6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301 407c0 8.284 6.716 15 15 15s15-6.716 15-15v-16h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181 497c0 8.284 6.716 15 15 15s15-6.716 15-15v-106h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316 452h-45v-61h-30v76c0 8.284 6.716 15 15 15h45v15c0 8.284 6.716 15 15 15s15-6.716 15-15v-30c0-8.284-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422 196c0-8.284-6.716-15-15-15h-16v30h16c8.284 0 15-6.716 15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497 301h-106v30h106c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482 256v-45h15c8.284 0 15-6.716 15-15s-6.716-15-15-15h-30c-8.284 0-15 6.716-15 15v45h-61v30h76c8.284 0 15-6.716 15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90 316c0 8.284 6.716 15 15 15h16v-30h-16c-8.284 0-15 6.716-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 196c0 8.284 6.716 15 15 15h106v-30h-106c-8.284 0-15 6.716-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 256v45h-15c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15v-45h61v-30h-76c-8.284 0-15 6.716-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226 226h60v60h-60z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.bae0a9ae9afe5cc3a04c4b6e6946fb09.svg";
export { ForwardRef as ReactComponent };